<template>
  <el-dialog :visible="visible" title="维护套图" width="1000px" @close="close">
    <div>
      <!-- <el-button v-for="(item, index) in list" :key="item.id" @click="swatchItem(index)">{{ item.name }}</el-button> -->
      <el-input
        :ref="`inputRef${index}`"
        class="imageName-item"
        :class="{ 'active-item': activeIndex === index }"
        maxlength="10"
        clearable
        auto-trim
        v-for="(item, index) in list"
        :key="item.id"
        :readonly="editNameIndex !== index"
        v-model="item.name"
        @click="swatchItem(index)"
        @blur="onBlur"
      >
        <template slot="append">
          <el-link icon="el-icon-edit" @click="editName(index)" style="margin-right: 5px"></el-link>
          <el-link icon="el-icon-delete" @click="deleteItem(index)" style="color: #f56c6c"></el-link>
        </template>
      </el-input>
      <el-button class="mt-10" v-if="list.length < 10" @click="swatchItem(-1)" icon="el-icon-circle-plus-outline">添加套图</el-button>
    </div>
    <div style="margin: 10px" v-if="list.length">
      <el-link @click="fillCurImages">引用当前商品图片填充</el-link>
    </div>
    <el-form class="form" ref="form" :model="form" :rules="rules" label-width="80px" v-if="list.length">
      <el-form-item label="商品主图：" prop="mainImages">
        <div>
          <BatchEditImages v-model="form.mainImages" refName="mainImages" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
        </div>
        <MutiImgUpload
          ref="mainImages"
          :limitNums="50"
          :mainImgNums="0"
          :size="150"
          limitSuffix=".jpg,.jpeg,.png"
          v-model="form.mainImages"
        />
        <p class="tips ft-12">支持批量传图，最多上传50张图片，支持jpg/jpge/png格式</p>
      </el-form-item>
      <el-form-item label="3:4主图：" prop="mainImages34">
        <div>
          <BatchEditImages v-model="form.mainImages34" refName="mainImages34" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
        </div>
        <MutiImgUpload
          ref="mainImages34"
          :limitNums="50"
          :mainImgNums="0"
          :size="150"
          limitSuffix=".jpg,.jpeg,.png"
          v-model="form.mainImages34"
        />
        <p class="tips ft-12">支持批量传图，最多上传50张图片，支持jpg/jpge/png格式</p>
      </el-form-item>
      <el-form-item label="商品详情图：">
        <div>
          <BatchEditImages v-model="form.detailImages" refName="detailImages" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages>
        </div>
        <MutiImgUpload
          ref="detailImages"
          :limitNums="50"
          :mainImgNums="0"
          :size="150"
          limitSuffix=".jpg,.jpeg,.png"
          v-model="form.detailImages"
        />
        <p class="tips ft-12">支持批量传图，最多上传50张图片，支持jpg/jpge/png格式</p>
      </el-form-item>
      <el-form-item label="规格图：" prop="speImages">
        <div><BatchEditImages v-model="form.speImages" refName="speImages" :getWidthAndHeights="getWidthAndHeights"></BatchEditImages></div>
        <div style="font-size: 12px;font-weight: 600;"> 规格名：{{ specificationName }}</div>
        <MutiImgUpload
          ref="speImages"
          :limitNums="specImgUrls.length"
          :mainImgNums="0"
          :imgNames="specImgNames"
          :size="150"
          :filterEmptyFile="false"
          :isSort="false"
          limitSuffix=".jpg,.jpeg,.png"
          v-model="form.speImages"
        />
      </el-form-item>
    </el-form>
    <template slot="footer">
      <el-button @click="close">取消</el-button>
      <el-button @click="ok" type="primary">确定</el-button>
    </template>
  </el-dialog>
</template>

<script>
import MutiImgUpload from '@/components/Uploads/MutiImgUpload';
import BatchEditImages from '@/components/prod/center/components/BatchEditImages.vue';
import { saveItemGroupPicture, deleteItemGroupPicture } from '@/api/prod/center/index.js';

import { cloneDeep } from 'lodash';

export default {
  components: {
    MutiImgUpload,
    BatchEditImages,
  },
  data() {
    return {
      list: [],
      opts: {},
      form: {},
      specificationName: '',
      specImgUrls: [],
      specImgNames: [],
      activeIndex: '',
      editNameIndex: '',
      deleteIds: [],
      visible: false,
      rules: {
        mainImages: [{ required: true, message: '至少要选择1张图片' }],
      },
    };
  },
  methods: {
    getWidthAndHeights(refName) {
      return this.$refs[refName].getWidthAndHeights ? this.$refs[refName].getWidthAndHeights() : [];
    },
    method_open(opts = {}) {
      this.opts = opts;
      const { list, activeIndex, specifications } = opts;
      this.handleSpeImages(specifications);
      this.list = list || [];
      this.swatchItem(activeIndex || 0);
      this.visible = true;
    },
    handleSpeImages(specifications) {
      const specImgNames = [];
      const specImgUrls = [];
      if (specifications?.length) {
        this.specificationName = specifications[0].name
        specifications[0].values.forEach(v => {
          specImgNames.push(v.value);
          specImgUrls.push(v.imageUrl);
        });
      }
      this.specImgNames = specImgNames;
      this.specImgUrls = specImgUrls;
    },
    swatchItem(index) {
      if (index === this.editNameIndex) return;
      const speImages = this.specImgUrls.map(img => '');
      if (index == -1) {
        this.list.push({
          name: `第${this.list.length + 1}套图`,
          mainImages: [],
          mainImages34: [],
          detailImages: [],
          speImages,
        });
        index = this.list.length - 1;
        this.editNameIndex = index;
      }
      this.activeIndex = index;
      const curItem = this.list[index]
      curItem.speImages = this.specImgNames.map((n, nIdx) => curItem.speImages[nIdx] || '')
      this.form = curItem;
      this.$nextTick(() => {
        this.focusInput(index);
      });
    },
    editName(index) {
      this.editNameIndex = index;
      this.focusInput(index);
    },
    onBlur() {
      this.editNameIndex = '';
    },
    deleteItem(index) {
      this.$confirm('确认删除吗?', '提示', {
        type: 'warning',
        width: '200px',
      }).then(async () => {
        const id = this.list[index].id;
        id && this.deleteIds.push(id)
        const deleteSucess = () => {
          this.list.splice(index, 1);
          if (this.list.length && index > 0) {
            this.swatchItem(index > 0 ? index - 1 : 0);
          } else {
            this.activeIndex = '';
            this.editNameIndex = '';
          }
        };
        deleteSucess();

        // if (id) {
        //   const res = await deleteItemGroupPicture({ id });
        //   if (res.result === 1) {
        //     deleteSucess();
        //   }
        // } else {
        //   deleteSucess();
        // }
      });
    },
    focusInput(index) {
      if (this.$refs[`inputRef${index}`]) {
        this.$refs[`inputRef${index}`][0].focus();
      }
    },
    fillCurImages() {
      const self_form = this.opts.selfForm || {};
      this.list[this.activeIndex] = {
        ...this.form,
        mainImages: self_form.mainImages || [],
        mainImages34: self_form.mainImages34 || [],
        detailImages: self_form.detailImages || [],
        speImages: cloneDeep(this.specImgUrls),
      };
      this.form = this.list[this.activeIndex];
    },
    close() {
      this.visible = false;
      this.opts.okFn && this.opts.okFn();
      this.opts = {};
      this.list = [];
      this.deleteIds = [];
      this.form = {};
    },
    async ok() {
      // 检查是否有重复名称
      const hasDuplicateName = this.list.some((item, index) => this.list.findIndex(i => i.name === item.name) !== index);
      if (hasDuplicateName) {
        this.$message.error('存在重复的套图名称');
        return;
      }

      const findItem = this.list.find(item => !item.mainImages?.length);
      if (findItem) {
        this.$message.error(`${findItem.name} 商品主图 必填`);
        return;
      }
      const companyId = this.$store.getters.userInfo.companyId;
      const scmItemPictureList = this.list.map((item, index) => {
        return {
          ...item,
          mainImages: JSON.stringify(item.mainImages || []),
          mainImages34: JSON.stringify(item.mainImages34 || []),
          detailImages: JSON.stringify(item.detailImages || []),
          speImages: JSON.stringify(item.speImages || []),
          speNames: JSON.stringify(this.specImgNames || []),
          companyId,
          baseItemId: this.opts.baseItemId,
          sort: index + 1,
        };
      });
      if (!this.opts.baseItemId) {
        // 新建
        this.$store.commit('mixture/caches_add', {
          type: "groupImages",
          data: scmItemPictureList,
        });
        this.close();
      } else {
        const res = await saveItemGroupPicture({
          companyId,
          baseItemId: this.opts.baseItemId,
          scmItemPictureList,
          pictureIds: this.deleteIds
        });
        if (res.result === 1) {
          this.$message.success('保存成功！');
          this.close();
        }
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.imageName-item {
  cursor: pointer;
  width: 180px;
  margin: 10px;
  ::v-deep .el-input__inner {
    border-right: none;
  }

  ::v-deep .el-input-group__append {
    padding: 0 4px;
  }
}
.active-item {
  ::v-deep .el-input__inner {
    color: #396cf3;
    border-color: #396cf3;
  }
  ::v-deep .el-input-group__append {
    border-color: #396cf3;
  }
}
</style>
